import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AdminDashboardLayout from './AdminDashboardLayout';
import ProfileTab from './tabs/ProfileTab';
import NotificationsTab from './tabs/NotificationsTab';
import PrivacyPolicyTab from './tabs/PrivacyPolicyTab';
import AppearanceTab from './tabs/AppearanceTab';
import ElectionInfoTab from './tabs/ElectionInfoTab';
import UpdateElection from './tabs/UpdateElection';
import Controls from './tabs/Controls';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      className={value === index ? 'block' : 'hidden'}
    >
      {value === index && <div className="pt-6">{children}</div>}
    </div>
  );
};

const ContentManagement: React.FC = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    // { label: 'Profile', component: <ProfileTab /> },
    // { label: 'Notifications', component: <NotificationsTab /> },
    { label: 'Legal Pages ', component: <PrivacyPolicyTab /> },
    { label: 'Add Election Info', component: <ElectionInfoTab /> },
    { label: 'Update Existing Election', component: <UpdateElection /> },
    { label: 'Controls', component: <Controls /> },
  ];

  useEffect(() => {
    // Check if there's a hash or state indicating the tab
    const hash = location.hash.replace('#', '');
    if (hash === 'Template') {
      setActiveTab(0); // Index of Template tab
    } else if (hash === 'election') {
      setActiveTab(1); // Index of Election Info tab
    } else if (hash === 'update') {
      setActiveTab(2);
    } else if (location.state && (location.state as any).activeTab !== undefined) {
      setActiveTab((location.state as any).activeTab);
    }
  }, [location]);

  const handleTabChange = (index: number) => {
    setActiveTab(index);
  };

  return (
    <AdminDashboardLayout role="SYSTEM_ADMIN">
      <div className="w-full">
        <h1 className="text-3xl font-bold mb-4 m-0">
          Content Management
        </h1>
        
        <div className="border-b border-gray-300 mb-0">
          <div className="flex border-b-2 overflow-x-auto border-gray-300">
            {tabs.map((tab, index) => (
              <button
                key={index}
                onClick={() => handleTabChange(index)}
                id={`settings-tab-${index}`}
                aria-controls={`settings-tabpanel-${index}`}
                className={`px-6 py-3 border-none bg-none whitespace-nowrap text-base cursor-pointer transition-all duration-200 outline-none ${
                  activeTab === index 
                    ? 'border-b-3 border-sky-500 text-sky-500 font-semibold' 
                    : 'border-b-3 border-transparent text-gray-600 font-normal hover:text-gray-800'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {tabs.map((tab, index) => (
          <TabPanel key={index} value={activeTab} index={index}>
            {tab.component}
          </TabPanel>
        ))}
      </div>
    </AdminDashboardLayout>
  );
};

export default ContentManagement;
